import React from "react";

/**
 * The Floodlight signature loader — a tiny floodlight pole on a pitch with a
 * sweeping amber beam. Used in place of generic spinners.
 *
 * Props:
 *   label:   string shown beneath the floodlight (default "switching on")
 *   compact: if true, renders a 96×64 inline version (for buttons / inline UI)
 *   color:   CSS colour to use for the beam (defaults to tenant primary)
 */
export const FloodlightLoader = ({ label = "switching on", compact = false, color, fullScreen = false, testId = "floodlight-loader" }) => {
    const style = color ? { "--fl-color": color } : undefined;
    const sizeClass = compact ? "fl-loader fl-loader--compact" : "fl-loader";
    const node = (
        <div
            data-testid={testId}
            className={sizeClass}
            style={style}
            role="status"
            aria-label={label}
        >
            <div className="fl-loader__beam" />
            <div className="fl-loader__head" />
            <div className="fl-loader__pole" />
            <div className="fl-loader__ground" />
            {!compact && <div className="fl-loader__label">{label}</div>}
        </div>
    );
    if (!fullScreen) return node;
    return (
        <div className="fixed inset-0 bg-[var(--sb-page)] flex items-center justify-center z-[100]">
            {node}
        </div>
    );
};

export default FloodlightLoader;
